import { render } from "./DuplicateIcon.vue?vue&type=template&id=0d19a013&ts=true"
import script from "./DuplicateIcon.ts?vue&type=script&lang=ts"
export * from "./DuplicateIcon.ts?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/RC.Estimatifs/rc-estimatifs-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__